import {
  FETCHING_CUSTOM_FORM_FIELDS, FETCHING_CUSTOM_FORM_FIELDS_SUCCEEDED, FETCHING_CUSTOM_FORM_FIELDS_FAILED,
  DELETING_CUSTOM_FORM_FIELD, DELETING_CUSTOM_FORM_FIELD_SUCCEEDED, DELETING_CUSTOM_FORM_FIELD_FAILED,
  FETCHING_CUSTOM_FORM_FIELD, FETCHING_CUSTOM_FORM_FIELD_SUCCEEDED, FETCHING_CUSTOM_FORM_FIELD_FAILED,
  CREATE_CUSTOM_FORM_FIELD, CREATING_CUSTOM_FORM_FIELD_SUCCEEDED, CREATING_CUSTOM_FORM_FIELD_FAILED,
  UPDATE_CUSTOM_FORM_FIELD, UPDATING_CUSTOM_FORM_FIELD_SUCCEEDED, UPDATING_CUSTOM_FORM_FIELD_FAILED,
  INVALIDATE_CUSTOM_FORM_FIELDS
} from 'constants/actionTypes';
  
import _ from 'lodash';
  
const initialState = {
  loading: false,
  deleting: false,
  creating: false,
  updating: false,
  invalidated: false,
  currentField: null,
  items: [],
  errors: null,
  pagination: {
    currentPage: -1,
    totalPages: 1
  }
};

function formFieldsReducer(state = initialState, action) {
  switch (action.type) {

    case FETCHING_CUSTOM_FORM_FIELDS: {
      const request = action.payload;

      const isPersonalization = Array.isArray(request.ignoreTypes) && request.ignoreTypes.length > 0;

      if (isPersonalization){
        return state;
      }
      
      return {
        ...state,
        loading: true,
      }
    }
  
    case FETCHING_CUSTOM_FORM_FIELDS_SUCCEEDED: {
      const { records, currentPage, recordsPerPage, totalPages, totalRecordsCount } = action.payload;
      let items = records || [];

      if(items.length > 0) {
        items = [...state.items, ...items];
        items = _.uniqBy(items, 'id');
      }
  
      return {
        ...state,
        loading: false,
        invalidated: false,
        items: items,
        pagination: {
          ...state.pagination,
          currentPage,
          totalPages,
          recordsPerPage,
          totalRecordsCount
        }
      }
    }
  
    case FETCHING_CUSTOM_FORM_FIELDS_FAILED: {
      var error = action.payload;
    
      return {
        ...state,
        loading: false,
        invalidated: false,
        error: error
      }
    }

    case DELETING_CUSTOM_FORM_FIELD: {
      return {
        ...state,
        deleting: true
      }
    }
  
    case DELETING_CUSTOM_FORM_FIELD_SUCCEEDED: {
      const deletedRecord = action.payload;
      let newRecords = [];

      if(deletedRecord) {
        newRecords = state.items.filter((item)=> item.id != deletedRecord.id);
      }
  
      return {
        ...state,
        loading: false,
        invalidated: false,
        items: newRecords,
        currentField: null
      }
    }
  
    case DELETING_CUSTOM_FORM_FIELD_FAILED: {
      var error = action.payload;
  
      return {
        ...state,
        deleting: false,
        error: error
      }
    }

    case FETCHING_CUSTOM_FORM_FIELD: {
      return {
        ...state,
        invalidated: true
      }
    }
  
    case FETCHING_CUSTOM_FORM_FIELD_SUCCEEDED: {
      const record = action.payload;
  
      return {
        ...state,
        invalidated: false,
        currentField: record
      }
    }
  
    case FETCHING_CUSTOM_FORM_FIELD_FAILED: {
      var error = action.payload;
  
      return {
        ...state,
        invalidated: false,
        error: error
      }
    }

    case CREATE_CUSTOM_FORM_FIELD: {
      return {
        ...state,
        creating: true
      }
    }
  
    case CREATING_CUSTOM_FORM_FIELD_SUCCEEDED: {
      const record = action.payload.response;

      let items = state.items;
      items = [...state.items, record];
  
      return {
        ...state,
        creating: false,
        invalidated: false,
        items: items,
        currentField: record
      }
    }
  
    case CREATING_CUSTOM_FORM_FIELD_FAILED: {
      var error = action.payload;
  
      return {
        ...state,
        creating: false,
        invalidated: false,
        error: error
      }
    }

    case UPDATE_CUSTOM_FORM_FIELD: {
      return {
        ...state,
        updating: true,
        invalidated: true
      }
    }
  
    case UPDATING_CUSTOM_FORM_FIELD_SUCCEEDED: {
      const record = action.payload.response;

      let items = [...state.items].filter(item => item.id);
      items = items.map(item => item.id == record.id ? record : item);
  
      return {
        ...state,
        updating: false,
        invalidated: false,
        currentField: record,
        items: items
      }
    }
  
    case UPDATING_CUSTOM_FORM_FIELD_FAILED: {
      var error = action.payload;
  
      return {
        ...state,
        updating: false,
        invalidated: false,
        error: error
      }
    }

    case INVALIDATE_CUSTOM_FORM_FIELDS: {
      return {
        ...state,
        updating: false,
        invalidated: true,
        items: [],
        currentField: null,
        pagination: {
          ...initialState.pagination
        }
      }
    }

    default:
        return state;
  }
}

export { formFieldsReducer };